export function formatArticleDate(
  iso: string,
  locale: string,
  month: "short" | "long",
) {
  return new Date(iso).toLocaleDateString(locale === "de" ? "de-DE" : "hr-HR", {
    year: "numeric",
    month,
    day: "numeric",
  });
}
